export const ACTIONS = {
  DASHBOARD_FETCH: 'DASHBOARD_FETCH',
  DASHBOARD_FETCH_START: 'DASHBOARD_FETCH_START',
  DASHBOARD_FETCH_SUCCESS: 'DASHBOARD_FETCH_SUCCESS',
  DASHBOARD_FETCH_FAILURE: 'DASHBOARD_FETCH_FAILURE',
  RESET_DASHBOARD_FETCH: 'RESET_DASHBOARD_FETCH',
};
